// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".internationalInput .select-country-container[data-v-52b6b762]{min-height:51px!important}", ""]);
// Exports
module.exports = exports;
